// extracted by css-extract-rspack-plugin
export default {"cls1":"PaywallPage-cls1_eBr","cls2":"PaywallPage-cls2_FEX PaywallPage-cls1_eBr"};